import { render, staticRenderFns } from "./WardSummary.vue?vue&type=template&id=782e8978&"
import script from "./WardSummary.vue?vue&type=script&lang=ts&"
export * from "./WardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('782e8978')) {
      api.createRecord('782e8978', component.options)
    } else {
      api.reload('782e8978', component.options)
    }
    module.hot.accept("./WardSummary.vue?vue&type=template&id=782e8978&", function () {
      api.rerender('782e8978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/WardSummary.vue"
export default component.exports